var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "131.25 61.25 437.5 437.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m350 288.75c62.719 0 113.75-51.031 113.75-113.75s-51.031-113.75-113.75-113.75-113.75 51.031-113.75 113.75 51.031 113.75 113.75 113.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m464.53 303.62c-3.1484-1.9414-7.1836-1.6875-10.09 0.64844-29.906 24.191-66.023 36.984-104.44 36.984s-74.523-12.793-104.43-36.984c-2.8789-2.3359-6.9297-2.5977-10.09-0.64844-65.266 40.188-104.23 109.86-104.23 186.38 0 4.8398 3.9219 8.75 8.75 8.75h420c4.8398 0 8.75-3.9102 8.75-8.75 0-76.52-38.965-146.2-104.22-186.38z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccount);
export default __webpack_public_path__ + "static/media/icon-account.d1198eb6d1fd3921ad1f29761d940a32.svg";
export { ForwardRef as ReactComponent };